import i from "../../../../../_virtual/uniqBy.js";
import u from "../../../../../_virtual/isFunction.js";
function m(r, t, n) {
  return t === !0 ? i(r, n) : u(t) ? i(r, t) : r;
}
export {
  m as getUniqPayload
};
